
import { DayCaresListType, Params } from 'app/dataTypes/dayCaresList'
import { map, values } from 'ramda'
import { Request } from '../../index'


type ResultApi = Record<number, {
  id: number
  title: string
}>

export const convertResult = (apiData: ResultApi): DayCaresListType => {
  return map(({
    id,
    title,
  }) => {
    return ({
      ID: String(id),
      title,
    })
  }, values(apiData))
}

export type ApiParams = {
  school_id: number,
  schoolyear_id: number,
}

export const convertParams = (params: Params): [ApiParams, null] => {
  const {
    schoolId,
    schoolYearId,
  } = params

  return [{
    school_id: parseInt(schoolId, 10),
    schoolyear_id: parseInt(schoolYearId, 10),
  }, null]
}

export const GET_DAY_CARES_LIST: Request<Params, DayCaresListType, void> = [
  'reports/day_cares_list',
  'get',
  ['data', 'day_cares'],
]
